var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearSky01 = function SvgClearSky01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clear_sky-01_svg2__a",
    x1: 28,
    x2: 178.39,
    y1: 164.16,
    y2: 30.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__b",
    x1: -15,
    x2: 135.38,
    y1: 115.9,
    y2: -18.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__c",
    x1: -10.31,
    x2: 140.07,
    y1: 121.16,
    y2: -12.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__d",
    x1: 66.32,
    x2: 216.7,
    y1: 207.17,
    y2: 73.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__e",
    x1: 31.32,
    x2: 181.7,
    y1: 167.88,
    y2: 33.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__f",
    x1: 24.69,
    x2: 175.07,
    y1: 160.44,
    y2: 26.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__g",
    x1: -29.5,
    x2: 120.89,
    y1: 99.63,
    y2: -34.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__h",
    x1: 85.5,
    x2: 235.89,
    y1: 228.7,
    y2: 94.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__i",
    x1: 71.01,
    x2: 221.39,
    y1: 212.43,
    y2: 78.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#clear_sky-01_svg2__a",
    id: "clear_sky-01_svg2__j",
    x1: 5.94,
    x2: 156.33,
    y1: 139.4,
    y2: 5.41
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.39 39.06c-33.47 0-60.61 27.13-60.61 60.61s27.13 60.61 60.61 60.61S161 133.14 161 99.67s-27.13-60.61-60.61-60.61m0 111.69c-28.21 0-51.08-22.87-51.08-51.08s22.87-51.08 51.08-51.08 51.08 22.87 51.08 51.08-22.87 51.08-51.08 51.08",
    style: {
      fill: "url(#clear_sky-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39 26.51c2.63 0 4.76-2.13 4.76-4.76V4.43c0-2.63-2.13-4.76-4.76-4.76s-4.76 2.13-4.76 4.76v17.32c0 2.63 2.13 4.76 4.76 4.76",
    style: {
      fill: "url(#clear_sky-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.47 94.9H5.15c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.76 4.76 4.76h17.32c2.63 0 4.76-2.13 4.76-4.76s-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#clear_sky-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.63 94.9h-17.32c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.76 4.76 4.76h17.32c2.63 0 4.76-2.13 4.76-4.76s-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#clear_sky-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.29 150c-1.22 0-2.44.46-3.37 1.39l-12.24 12.24a4.756 4.756 0 0 0 0 6.73 4.756 4.756 0 0 0 6.73 0l12.24-12.24a4.77 4.77 0 0 0 0-6.74 4.75 4.75 0 0 0-3.37-1.39Z",
    style: {
      fill: "url(#clear_sky-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.73 27.56c-1.22 0-2.44.47-3.37 1.4L152.12 41.2c-1.86 1.86-1.86 4.88 0 6.73a4.756 4.756 0 0 0 6.73 0l12.24-12.24c1.86-1.86 1.86-4.88 0-6.73-.93-.93-2.15-1.4-3.37-1.4Z",
    style: {
      fill: "url(#clear_sky-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.92 47.93c1.86 1.86 4.88 1.86 6.74 0s1.86-4.88 0-6.73L36.42 28.96a4.756 4.756 0 0 0-6.74 0c-1.86 1.86-1.86 4.88 0 6.73z",
    style: {
      fill: "url(#clear_sky-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 151.4c-.93-.93-2.15-1.39-3.37-1.39s-2.44.46-3.37 1.39a4.77 4.77 0 0 0 0 6.74l12.24 12.24c1.86 1.86 4.88 1.86 6.73 0a4.756 4.756 0 0 0 0-6.73l-12.24-12.24Z",
    style: {
      fill: "url(#clear_sky-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39 172.83c-2.63 0-4.76 2.13-4.76 4.76v17.32c0 2.63 2.13 4.76 4.76 4.76s4.76-2.13 4.76-4.76v-17.32c0-2.63-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#clear_sky-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26 61.57c-.99 0-2 .31-2.85.95l-2.13 1.6a52.34 52.34 0 0 0-18.46 25.94l-1.05 3.28a4.767 4.767 0 0 0 9.08 2.91l1.05-3.28A42.84 42.84 0 0 1 83 71.75l2.13-1.6c2.1-1.58 2.53-4.56.95-6.67a4.75 4.75 0 0 0-3.81-1.9Z",
    style: {
      fill: "url(#clear_sky-01_svg2__j)"
    }
  }));
};
export default SvgClearSky01;